export default __webpack_public_path__ + "static/media/BillOnlyWorkflowV7.bb1142fa.pdf";